/**
 * Merge per-namespace flat catalogs into one flat record. Callers pass catalogs
 * in ALL_NAMESPACES order, so later namespaces win collisions as before.
 */
export function mergeFlat(
  ...catalogs: Record<string, string>[]
): Record<string, string> {
  return Object.assign({}, ...catalogs);
}
